// @flow
import React, { PureComponent } from 'react';
import { View, StyleSheet, Image } from 'react-native';
import { EmphasizedSubText } from 'trpc-react-native-ui';

import { FullButton, GradientPage } from '../../../components/common/index';
import theme from '../../../theme-config';

import type { NavigationRoute, NavigationScreenProp } from '@react-navigation/compat';

export default class RedirectToIdentityRequirementOrDashboard extends PureComponent<Props> {
  styles = getStyles();
  render() {
    const { image, title, text, subtitle, navigation } = this.props;
    return (
      <GradientPage style={this.styles.container}>
        <EmphasizedSubText style={this.styles.title} text={title} emphStyle={this.styles.boldText} />
        <EmphasizedSubText style={this.styles.text} text={subtitle} emphStyle={this.styles.boldText} />
        <Image style={this.styles.image} source={image} resizeMode="contain" />
        <EmphasizedSubText style={this.styles.text} text={text} emphStyle={this.styles.boldText} />
        <View style={{ justifyContent: 'space-around', width: '100%' }}>
          <FullButton onPress={() => navigation.navigate(this.props.redirectTo)} text={this.props.confirmButtonText} />
        </View>
      </GradientPage>
    );
  }
}

type Props = StateProps;

export type StateProps = {
  image: number,
  title: string,
  text: string,
  subtitle: string,
  confirmButtonText: string,
  redirectTo: string,
  navigation: NavigationScreenProp<NavigationRoute>,
};

function getStyles() {
  return StyleSheet.create({
    boldText: {
      fontWeight: 'bold',
    },
    container: {
      alignItems: 'center',
      flex: 1,
      justifyContent: 'space-around',
      marginHorizontal: 17,
    },
    image: {
      height: 200,
      marginBottom: 25,
      marginLeft: 10,
      marginTop: 30,
      width: 150,
    },
    text: {
      fontSize: 18,
      textAlign: 'center',
    },
    title: {
      color: theme.headerTextColor,
      fontSize: 24,
      textAlign: 'center',
    },
  });
}
